import { render, staticRenderFns } from "./BPDownBanner.vue?vue&type=template&id=3f26db26&"
import script from "./BPDownBanner.vue?vue&type=script&lang=js&"
export * from "./BPDownBanner.vue?vue&type=script&lang=js&"
import style0 from "./BPDownBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports